import { createComponent } from '@carvana/merch-components';
import { EpicSection, type EpicSectionProps } from '@/vdp/styles';
import ShareIcon from '~/icons/Share';

export const Section = createComponent<EpicSectionProps>(EpicSection, {
  className:
    'flex flex-row items-start justify-between border-t border-grey-2 px-16 pb-0 pt-12 l:px-32 l:pt-16'
});

export const SectionContent = createComponent('div', {
  className: 'flex flex-row items-center gap-8 pb-12 l:pb-16'
});

export const Crumbs = createComponent('a', {
  className: 'whitespace-nowrap text-grey-5 tl-body-xs l:tl-body-s'
});

export const ActionsContainer = createComponent('div', {
  className: 'flex items-start gap-16 '
});

export const ShareButton = createComponent(ShareIcon, {
  className: 'pointer-events-auto flex h-16 w-16 fill-blue-6 m:h-24 m:w-24'
});
